









import 'vue-awesome/icons/exclamation-triangle'

export default
  name: 'editable_balance'
  props: ['record']
  components:
    balance: require('components/inside/elements/balance.vue').default
  data: ->
    edit_mode: false
    local_balance: null
  computed:
    is_account: -> @record.constructor.className == 'Account'
    is_virtual: -> @record.constructor.className == 'Virtual'
  methods:
    edit: ->
      @edit_mode = true
      @local_balance = @record.balance
      setTimeout (=> $(@$el).find('input').select().focus()), 50
    unedit: ->
      @edit_mode = false
    save: ->
      return if @edit_mode == false
      @edit_mode = false
      if @local_balance != '' && @local_balance != null
        @local_balance = Number(@local_balance)
        record = _.clone @record
        record.balance = @local_balance
        if @is_account
          @$store.dispatch('saveAccount', record)
          HM.track("account-balance_update")
        if @is_virtual
          @$store.dispatch('saveVirtual', record)
          HM.track("virtual-balance_update")
